<template>
    <router-view/>
</template>
<script>
export default {
    name: 'CategoryPage',
}
</script>